module.exports = __webpack_public_path__ + "static/media/flag-united-states.6f91badf.svg";